module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "viewContainer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOrder),
      expression: "isOrder"
    }],
    on: {
      "listenEdit": _vm.showOrder
    }
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('el-form', {
    staticClass: "findform",
    attrs: {
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "25%"
    },
    attrs: {
      "label": "文章标题："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入内容",
      "maxlength": "10"
    },
    model: {
      value: (_vm.filters.EnterpriseName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "EnterpriseName", $$v)
      },
      expression: "filters.EnterpriseName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "25%"
    },
    attrs: {
      "label": "文章分类："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filters.MediaType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "MediaType", $$v)
      },
      expression: "filters.MediaType"
    }
  }, _vm._l((_vm.MediaTypeArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "25%"
    },
    attrs: {
      "label": "文章状态："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filters.articleState),
      callback: function($$v) {
        _vm.$set(_vm.filters, "articleState", $$v)
      },
      expression: "filters.articleState"
    }
  }, _vm._l((_vm.articleStateArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("文章审核发布")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-right": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.endDeletegood()
      }
    }
  }, [_vm._v("批量删除")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.showAdd()
      }
    }
  }, [_vm._v("新 增")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    staticClass: "invoice_tab",
    attrs: {
      "data": _vm.articleDataList,
      "stripe": "",
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "60px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "文章标题",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.title
          }
        }, [_vm._v(_vm._s(scope.row.title))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "文章分类",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.mediaTypeName))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发布时间",
      "align": "center",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.publishTime))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "阅读量",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("playvolume")(scope.row.browse)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "收藏",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("playvolume")(scope.row.collection)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "转发",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("playvolume")(scope.row.forward)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "评论",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("playvolume")(scope.row.comment)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "点赞",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("playvolume")(scope.row.fabulous)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "最后操作人",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.lastEditUserName))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "最后操作时间",
      "align": "center",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.lastEditTime))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.stateName))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center",
      "width": "235"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.state == 3) ? _c('span', {
          staticClass: "ashSpan"
        }, [_vm._v(" 审核 ")]) : _vm._e(), _vm._v(" "), (scope.row.state == 1) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.endArticleReview(scope.row)
            }
          }
        }, [_vm._v("审核")]) : _vm._e(), _vm._v(" "), (scope.row.state == 2) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.articleUnsealed(scope.row)
            }
          }
        }, [_vm._v("解封")]) : _vm._e(), _vm._v(" "), (scope.row.state == 4) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.articlesBanned(scope.row)
            }
          }
        }, [_vm._v("封禁")]) : _vm._e(), _vm._v(" "), _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.cliSeePartner(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        }), _vm._v(" 查看 ")]), _vm._v(" "), _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.editArticle(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v(" 编辑 ")]), _vm._v(" "), _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.deleteData(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v(" 删除 ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndex,
      "page-size": 10,
      "total": _vm.totalRowsCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])]), _vm._v(" "), (_vm.isSeePartnerPopup) ? _c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("新建文章")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin": "6px 10px 0 0"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.showOrder()
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "watch_msg"
  }, [_c('b', {
    staticClass: "typeface"
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "margin": "10px 0 30px 0"
    }
  }, [_c('el-form', {
    staticClass: "formItem"
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "42%"
    },
    attrs: {
      "label": "文章名称 :",
      "label-width": "88px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入文章名称 (30字以内)",
      "maxlength": "30",
      "disabled": _vm.disabledArticle
    },
    model: {
      value: (_vm.articleTitle),
      callback: function($$v) {
        _vm.articleTitle = $$v
      },
      expression: "articleTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "42%"
    },
    attrs: {
      "label": "文章分类 :",
      "label-width": "88px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "background": "#fff",
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择",
      "disabled": _vm.disabledArticle
    },
    model: {
      value: (_vm.articleClassification),
      callback: function($$v) {
        _vm.articleClassification = $$v
      },
      expression: "articleClassification"
    }
  }, _vm._l((_vm.articleClassificationArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleClassification != 0),
      expression: "articleClassification != 0"
    }],
    staticStyle: {
      "width": "86%"
    },
    attrs: {
      "label": "封面图片 :",
      "label-width": "88px"
    }
  }, [_c('div', {
    staticClass: "coverPhoto",
    staticStyle: {
      "display": "inline-block"
    }
  }, [(_vm.articleClassification == 0 || _vm.articleClassification == 2 && _vm.videoSrc == '') ? [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })] : _vm._e(), _vm._v(" "), (_vm.articleClassification == 1 || _vm.articleClassification == 2 && _vm.videoSrc) ? _c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "auto-upload": false,
      "show-file-list": false,
      "before-upload": _vm.beforeUploadCover,
      "on-change": _vm.changeUpload,
      "disabled": _vm.disabledArticle
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticStyle: {
      "width": "80px",
      "height": "80px"
    },
    attrs: {
      "id": "canvas",
      "src": _vm.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("建议尺寸：宽度应为1080px, 高度不小于607px，支持的图片格式：jpg、png !")])]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "canvasa",
      "hidden": "",
      "width": "1080",
      "height": "607"
    }
  }), _vm._v(" "), (_vm.articleClassification == 1) ? _c('el-form-item', {
    staticStyle: {
      "width": "86%"
    },
    attrs: {
      "label": "图片 :",
      "label-width": "88px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100vh",
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_vm._l((_vm.imgarrData), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "display": "inline-block",
        "position": "relative"
      }
    }, [(_vm.seeArticle) ? _c('img', {
      staticClass: "deletePicture",
      attrs: {
        "src": require("../../assets/img/aicon36.png")
      },
      on: {
        "click": function($event) {
          return _vm.deleteimg(index, item)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('el-image', {
      staticClass: "imgPicture",
      attrs: {
        "src": item,
        "preview-src-list": _vm.imgarrData
      },
      on: {
        "click": _vm.handleClickItem
      }
    })], 1)
  }), _vm._v(" "), (_vm.seeArticle) ? _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isdisabled),
      expression: "isdisabled"
    }],
    staticClass: "upload avatar-uploader",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "action": "",
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.CoverImg) ? _c('img', {
    staticClass: "avatar",
    staticStyle: {
      "width": "80px",
      "height": "80px"
    },
    attrs: {
      "src": _vm.CoverImg
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v(" 建议尺寸：宽度应为1080px, 高度不小于607px，支持的图片格式：jpg、png。")])]) : _vm._e(), _vm._v(" "), (_vm.articleClassification == 2) ? _c('el-form-item', {
    staticStyle: {
      "width": "86%"
    },
    attrs: {
      "label": "视频 :",
      "label-width": "88px"
    }
  }, [(_vm.videoSrc) ? _c('div', {
    staticClass: "videoClass"
  }, [_c('span', {
    staticClass: "previewingVideo",
    on: {
      "click": function($event) {
        return _vm.newSeevideo(_vm.videoSrc)
      }
    }
  }, [(_vm.videoImg) ? _c('img', {
    attrs: {
      "src": _vm.videoImg
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/img/spfm.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "iconcontainer"
  }, [_c('img', {
    staticClass: "playIcon",
    attrs: {
      "src": require("../../assets/img/play.png")
    }
  })])]), _vm._v(" "), (_vm.videoSrc) ? _c('img', {
    staticClass: "chahao",
    attrs: {
      "src": require("../../assets/img/aicon36.png")
    },
    on: {
      "click": function($event) {
        return _vm.delvideo()
      }
    }
  }) : _vm._e()]) : _c('el-upload', {
    staticClass: "avatar-uploader activeUploadImg",
    attrs: {
      "action": "",
      "accept": "video/*",
      "before-upload": _vm.handleFile
    }
  }, [(_vm.videoFlag) ? _c('el-progress', {
    attrs: {
      "type": "circle",
      "percentage": _vm.videoUploadPercent,
      "width": 80,
      "height": 80
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("视频格式仅支持: mp4. 视频大小不能超过 50MB !")])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "label": "关联品牌商品：",
      "label-width": "100px"
    }
  }, [(_vm.seeArticle) ? _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.brandArr.length < 5),
      expression: "brandArr.length < 5"
    }],
    staticClass: "el-icon-plus avatarUploaderIcon",
    on: {
      "click": _vm.addSpecialOffer
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isshowbrand) ? _vm._l((_vm.brandArr), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "display": "inline-block",
        "position": "relative"
      }
    }, [(_vm.seeArticle) ? _c('img', {
      staticClass: "deletePP",
      attrs: {
        "src": require("../../assets/img/aicon36.png")
      },
      on: {
        "click": function($event) {
          return _vm.deleteBrand(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.logoUrl) ? _c('img', {
      staticClass: "brandImg",
      attrs: {
        "src": item.logoUrl
      }
    }) : _vm._e()])
  }) : _vm._e()], 2), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "label": "添加标签：",
      "label-width": "88px"
    }
  }, [(_vm.seeLabel) ? _c('span', {
    staticClass: "choice",
    on: {
      "click": _vm.choosekong
    }
  }, [_vm._v("添加标签 >>")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.homenamearr), function(item, index) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.name),
        expression: "item.name"
      }],
      key: index,
      staticClass: "labelSpan"
    }, [_vm._v("\r\n            " + _vm._s(item.name) + " "), (_vm.seeLabel) ? _c('i', {
      staticClass: "el-icon-close",
      on: {
        "click": function($event) {
          return _vm.deleteLabel(item.id)
        }
      }
    }) : _vm._e()])
  })], 2), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "label": "内容 :",
      "label-width": "88px"
    }
  }, [_c('wjEditor', {
    attrs: {
      "desc": _vm.ueditorValue
    },
    on: {
      "change": _vm.contentChangeOne
    }
  })], 1), _vm._v(" "), _c('el-form', {
    staticClass: "formItem"
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "label": "发布人 :",
      "label-width": "88px"
    }
  }, [(_vm.seeArticle) ? _c('span', {
    staticClass: "publisherBtn",
    on: {
      "click": _vm.handleAddPublisher
    }
  }, [_vm._v(" 添加发布人 ")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "label-width": "88px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%",
      "text-align": "center"
    }
  }, [(_vm.LogoUrl) ? _c('img', {
    staticStyle: {
      "width": "80px",
      "height": "80px",
      "border-radius": "50%"
    },
    attrs: {
      "src": _vm.LogoUrl
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v(_vm._s(_vm.publisherTitle))])])])], 1)], 1), _vm._v(" "), (_vm.seeArticle) ? _c('div', {
    staticClass: "gudingdibu"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.showOrder()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.btnSubmit()
      }
    }
  }, [_vm._v("提交")])], 1) : _vm._e(), _vm._v(" "), (_vm.seeAuditButton) ? _c('div', {
    staticClass: "gudingdibu"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.adoptToExamine(1)
      }
    }
  }, [_vm._v("审核通过")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.adoptToExamine(2)
      }
    }
  }, [_vm._v("拒绝通过")])], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "品牌店/特价商品",
      "visible": _vm.brandStorePopup,
      "center": true,
      "width": "40%"
    },
    on: {
      "update:visible": function($event) {
        _vm.brandStorePopup = $event
      }
    }
  }, [_c('el-form', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "50%",
      "margin-right": "10px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.KeywordName),
      callback: function($$v) {
        _vm.KeywordName = $$v
      },
      expression: "KeywordName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.handleSearch()
      }
    }
  }, [_vm._v("搜 索")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "brandDiv"
  }, [_vm._l((_vm.brandStoreList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "brandStoreClass"
    }, [_c('div', {
      staticClass: "dlStyle"
    }, [_c('div', {
      staticClass: "dtDiv"
    }, [_c('img', {
      staticClass: "dtImage",
      attrs: {
        "src": item.logoUrl
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ddDiv"
    }, [_c('b', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.address))])])]), _vm._v(" "), _c('div', {
      staticClass: "confirmBtn",
      class: {
        noPrice: item.type != 2
      }
    }, [(item.type == 2) ? _c('p', [_vm._v("类别: "), _c('strong', [_vm._v(_vm._s(item.goodsBrandType))])]) : _vm._e(), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.addBrandStore(item)
        }
      }
    }, [_vm._v("添 加")])], 1)])
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showThereIsNoResult),
      expression: "showThereIsNoResult"
    }],
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("查无结果")])], 2)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "标签",
      "visible": _vm.labelPopup,
      "width": "800px",
      "before-close": _vm.handleClose2
    },
    on: {
      "update:visible": function($event) {
        _vm.labelPopup = $event
      }
    }
  }, [_c('div', {
    staticClass: "chooseDia"
  }, _vm._l((_vm.homearr), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "searchTop"
    }, [_c('span', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "searchBot"
    }, _vm._l((item.tag), function(item, index) {
      return _c('p', {
        key: index,
        class: {
          activeP: _vm.isSelect(item.id)
        },
        on: {
          "click": function($event) {
            return _vm.endSelectLabel(item)
          }
        }
      }, [_vm._v(_vm._s(item.name))])
    }), 0)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "chooseBtn"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.preservationLabel
    }
  }, [_vm._v("保 存")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "add_order_cancle",
    attrs: {
      "title": "审核",
      "center": true,
      "width": "30%",
      "visible": _vm.isToExamine
    },
    on: {
      "update:visible": function($event) {
        _vm.isToExamine = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入审核备注",
      "maxlength": "200",
      "rows": 3
    },
    model: {
      value: (_vm.shenmark),
      callback: function($$v) {
        _vm.shenmark = $$v
      },
      expression: "shenmark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0",
      "text-align": "center"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeAdopt),
      expression: "seeAdopt"
    }],
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.endToExamine(true)
      }
    }
  }, [_vm._v("确认审核")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeRefuse),
      expression: "seeRefuse"
    }],
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.endToExamine(false)
      }
    }
  }, [_vm._v("拒绝")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.isToExamine = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择发布人",
      "visible": _vm.xzfbr,
      "width": "35%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.xzfbr = $event
      }
    }
  }, [_c('el-form', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "60%",
      "margin-right": "10px"
    },
    attrs: {
      "label": "发布人手机号："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入发布人手机号"
    },
    model: {
      value: (_vm.publisherPhone),
      callback: function($$v) {
        _vm.publisherPhone = $$v
      },
      expression: "publisherPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.finddes()
      }
    }
  }, [_vm._v("查 询")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "disoutline"
  }, [_vm._l((_vm.desarr), function(item, index) {
    return _c('p', {
      key: index,
      staticClass: "disinline",
      on: {
        "click": function($event) {
          return _vm.handleGetdesId(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.faceUrl
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.nickName))]), _vm._v(" "), _c('el-radio', {
      staticClass: "elRadio",
      attrs: {
        "label": item.id
      },
      model: {
        value: (_vm.choiceRadioId),
        callback: function($$v) {
          _vm.choiceRadioId = $$v
        },
        expression: "choiceRadioId"
      }
    }, [_vm._v("选择")])], 1)
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nofind),
      expression: "nofind"
    }],
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("查无结果")])], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.makedes()
      }
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.xzfbr = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "图片剪裁",
      "visible": _vm.cropping,
      "append-to-body": "",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.cropping = $event
      }
    }
  }, [_c('div', {
    staticClass: "cropper-content"
  }, [_c('div', {
    staticClass: "cropper"
  }, [_c('vueCropper', {
    ref: "cropper",
    attrs: {
      "img": _vm.option.img,
      "outputSize": _vm.option.size,
      "fixedBox": _vm.option.fixedBox,
      "outputType": _vm.option.outputType,
      "full": _vm.option.full,
      "canMove": _vm.option.canMove,
      "infoTrue": _vm.option.infoTrue,
      "canMoveBox": _vm.option.canMoveBox,
      "original": _vm.option.original,
      "autoCrop": _vm.option.autoCrop,
      "info": true,
      "fixed": _vm.option.fixed,
      "fixedNumber": _vm.option.fixedNumber,
      "centerBox": _vm.option.centerBox,
      "autoCropWidth": _vm.option.autoCropWidth,
      "autoCropHeight": _vm.option.autoCropHeight
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.cropping = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v("确认")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "视频播放",
      "visible": _vm.videoVisible,
      "width": "30%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.videoVisible = $event
      },
      "close": _vm.closeVideo
    }
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "video-player vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptions
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-79071928!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/contentManagement/articleReviewAndRelease.vue
// module id = 1714
// module chunks = 3